<div class="rounded-2xl bg-white p-[16px] shadow-[0px_0px_8px_0px_rgba(0,0,0,0.12)]">
  <app-subcategory-filters-component (applyFilters)="applyFilters($event)" (resetFilters)="resetFilters()" />

  <app-subcategory-table-component
    [subcategories]="subcategories()"
    [state]="state()"
    [currentPage]="currentPage()"
    [itemsPerPage]="itemsPerPage()"
    [isFiltersApplied]="isFiltersApplied()"
    (retry)="loadSubcategories()"
    (viewSubcategory)="onViewSubcategory($event)"
    (editSubcategory)="onEditSubcategory($event)"
    (deleteSubcategory)="openDeleteDialog($event)"
    (activateSubcategory)="openToggleDialog($event, true)"
    (deactivateSubcategory)="openToggleDialog($event, false)" />
</div>

@if (state() === "success") {
  <app-pagination
    [itemsPerPage]="itemsPerPage()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="onPageChange(currentPage() - 1)"
    (nextPage)="onPageChange(currentPage() + 1)"
    (goToPage)="onPageChange($event)"
    (changePageNumber)="onPageSizeChange(+$event)" />
}

@if (subcategoryToToggle()) {
  <app-confirmation-dialog
    layout="start"
    [title]="toggleTitle()"
    [description]="toggleDescription()"
    [confirmContent]="toggleConfirm()"
    [cancelContent]="deleteCancel"
    [isLoading]="toggling()"
    [error]="toggleError()"
    (onSubmit)="confirmToggle()"
    (onCancel)="closeToggleDialog()" />
}

@if (subcategoryToDelete()) {
  <app-confirmation-dialog
    layout="start"
    [title]="deleteTitle"
    [description]="deleteDescription()"
    [confirmContent]="deleteConfirm"
    [cancelContent]="deleteCancel"
    [isLoading]="deleting()"
    [error]="deleteError()"
    (onSubmit)="confirmDelete()"
    (onCancel)="closeDeleteDialog()" />
}

@if (showSuccessMessage()) {
  <app-successful-notification type="success" [title]="deleteSuccess" />
}
